import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { CheckIcon, SparklesIcon, AlertCircleIcon } from 'lucide-react';
import { trackInitiateCheckout, trackLead, trackViewContent } from './MetaPixel';
export function PricingSection() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          trackViewContent();
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.5
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const handleGetStarted = () => {
    trackInitiateCheckout();
    window.open('https://buy.stripe.com/7sY7sM4gh69WcVo3vJdnW07', '_blank');
  };
  const handleBookCall = () => {
    trackLead();
    window.open('https://api.viridiaanalytics.com/widget/booking/hv5pIfS27zbJCMMGNnkJ', '_blank');
  };
  const features = ['Instant replies on ONE platform (Yelp, Facebook, OR Instagram)', 'Automatic booking on your Google Calendar', 'Customer tracker (CRM) to see all your leads', 'We set up everything for you', 'We keep it running and fix any issues', 'Monthly report showing how many jobs you booked', 'Text/email support whenever you need help'];
  return <section ref={sectionRef} id="pricing" className="py-20 px-6 bg-white" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-172">
          <h2 className="text-4xl md:text-5xl font-bold text-[var(--jet-black)] mb-4" data-id="element-173">
            Simple Pricing. Everything Included.
          </h2>
          <p className="text-xl text-[var(--graphite-gray)]" data-id="element-174">
            One price. No surprises. Cancel anytime.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-[var(--jet-black)] to-[var(--graphite-gray)] rounded-2xl p-8 md:p-12 text-white shadow-2xl border-4 border-[var(--viridia-green)]" data-id="element-175">
          <div className="text-center mb-8" data-id="element-176">
            <Badge variant="success" data-id="element-177">
              <SparklesIcon className="inline w-4 h-4 mr-1" data-id="element-178" />
              No Setup Fee (Save $497)
            </Badge>
            <div className="mt-6" data-id="element-179">
              <div className="text-6xl md:text-7xl font-bold mb-2" data-id="element-180">
                $297
                <span className="text-2xl text-gray-400 font-normal" data-id="element-181">
                  /month
                </span>
              </div>
              <p className="text-xl text-gray-300" data-id="element-182">
                For ONE platform (Yelp, Facebook, or Instagram)
              </p>
              <p className="text-sm text-gray-400 mt-2" data-id="element-183">
                Need multiple platforms? We can add more for additional cost.
              </p>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.4
        }} className="bg-orange-500 text-white rounded-lg p-4 mb-8 flex items-center gap-3" data-id="element-184">
            <AlertCircleIcon className="w-6 h-6 flex-shrink-0" data-id="element-185" />
            <p className="font-semibold" data-id="element-186">
              Only 5 spots left this month (we can only onboard so many at once)
            </p>
          </motion.div>

          <div className="mb-8" data-id="element-187">
            <p className="text-xl font-bold mb-4" data-id="element-188">Everything You Get:</p>
            <div className="space-y-3" data-id="element-189">
              {features.map((feature, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + index * 0.05
            }} className="flex items-start gap-3" data-id="element-190">
                  <CheckIcon className="w-6 h-6 text-[var(--viridia-green)] flex-shrink-0 mt-0.5" data-id="element-191" />
                  <span className="text-lg" data-id="element-192">{feature}</span>
                </motion.div>)}
            </div>
          </div>

          <div className="space-y-4" data-id="element-193">
            <Button size="lg" fullWidth onClick={handleGetStarted} data-id="element-194">
              Get Started Now - $297/month
            </Button>
            <button onClick={handleBookCall} className="w-full text-center text-gray-300 hover:text-white transition-colors text-sm underline" data-id="element-195">
              Want to talk first? Book a call
            </button>
          </div>

          <p className="text-center text-sm text-gray-400 mt-6" data-id="element-196">
            Live in 2-3 days • Cancel anytime • No contracts
          </p>
        </motion.div>
      </div>
    </section>;
}